import React, { useState, useEffect } from 'react';
import { useAuthnMe } from '../AuthnMeProvider';
import { HOME_PATH } from '../utils/homePath';

export interface HomePageWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper for home page: redirects authenticated users to the dashboard home, or shows children (default bot).
 */
export function HomePageWrapper({ children }: HomePageWrapperProps) {
  const { isAuthenticated, isLoading, user } = useAuthnMe();
  const [redirecting, setRedirecting] = useState(false);
  const [showDefault, setShowDefault] = useState(false);

  useEffect(() => {
    if (isLoading || redirecting || showDefault) return;
    if (isAuthenticated) {
      // Resellers go straight to the reseller dashboard
      if (user?.roles?.includes('reseller')) {
        window.location.href = '/reseller';
        return;
      }

      setRedirecting(true);
      window.location.href = HOME_PATH;
    } else {
      setShowDefault(true);
    }
  }, [isAuthenticated, isLoading, user, redirecting, showDefault]);

  if (isLoading || redirecting) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'var(--bg)',
          color: 'var(--text)',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div className="login-spinner" style={{ width: 40, height: 40, margin: '0 auto 1rem' }} />
          <p>{redirecting ? 'Redirecting...' : 'Loading...'}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

export default HomePageWrapper;
